import { getTranslationFallback } from '../../utils/translation.utils';
import ProductFilterBase from './product-filter-base.model';
import { IProductFilterDTO, ProductFilterTypes } from './product-filter-base.model';

export default class ProductFilterSlider extends ProductFilterBase {
  max = 1;
  min = 0;
  step = 1;
  type = ProductFilterTypes.Slider;

  static create(data: IProductFilterDTO): ProductFilterSlider {
    return Object.assign(new ProductFilterSlider(), data, {
      name: getTranslationFallback(`dcp.search.facet.${data.code}`, data.displayName ?? data.name),
      minFormatted: data.minFormatted ?? 0,
      maxFormatted: data.maxFormatted ?? 1,
      fromFormatted: data.fromFormatted ?? data.minFormatted ?? 0,
      toFormatted: data.toFormatted ?? data.maxFormatted ?? 0,
      label: getTranslationFallback(
        `dcp.search.facetCode.${data.code}.${data.facetDisplayType}`,
        data.values[0]?.name ?? 'from {from} to {to}',
      ),
      value: [data.from ?? data.min ?? 0, data.to ?? data.max ?? 1],
    });
  }

  clone(): ProductFilterSlider {
    return ProductFilterSlider.create(this);
  }

  isSelected(): boolean {
    const from = this.getFromValue();
    const to = this.getToValue();
    const { min, max } = this;

    return from > min || to < max;
  }

  isMaxSlider(): boolean {
    return this.value.length === 1;
  }

  getFromValue(): number {
    return this.isMaxSlider() ? this.min : Number(this.value[0]);
  }

  getToValue(): number {
    return this.isMaxSlider() ? this.value[0] : Number(this.value[1]);
  }

  getResetValue(): number[] {
    let resetValue;

    if (this.isMaxSlider()) {
      resetValue = [this.max];
    } else {
      resetValue = [this.min, this.max];
    }

    return resetValue;
  }

  getQueryValue(): string {
    const from = this.getFromValue();
    const to = this.getToValue();

    return `:${this.code}:[${from} TO ${to}]`;
  }
}
